<!-- QuillViewer.vue -->
<template>
<!--  <div class="quill-viewer ql-editor" v-html="content"></div>-->
  <div class="ql-snow">
    <div class="ql-editor" v-html="content"></div>
  </div>
</template>

<script>
// 导入官方样式
import 'quill/dist/quill.snow.css'

export default {
  name: 'QuillViewer',
  props: {
    content: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.ql-editor {
  font-family: Arial, sans-serif;
}

</style>

